module.exports = __webpack_public_path__ + "media/components/shared/nav_bar_images/arrow_forward-062c17d0917808453ef215dba91a1f1a.svg";